import { Box } from '@mui/material';
import { SOURCE_COLORS, DEVIATION_COLORS, devClass } from '../constants';

// Single shared input. Used by Stage 2 matrix + blended row, and Stage 4 inline-fix panel.
// Renders:
//   • left-border 3px stripe coloured per source (agreement / override / standard / manual)
//   • background tint based on deviation vs std (higher = red, lower = green)
export default function TatCellInput({
  value, std, source = 'manual', onChange, title, hasError = false,
}) {
  const dev = devClass(std, value);
  const bg = hasError ? '#fff5f5'
    : dev === 'higher' ? DEVIATION_COLORS.higher.bg
    : dev === 'lower' ? DEVIATION_COLORS.lower.bg
    : '#fff';
  const fg = hasError ? '#c62828'
    : dev === 'higher' ? DEVIATION_COLORS.higher.fg
    : dev === 'lower' ? DEVIATION_COLORS.lower.fg
    : 'inherit';

  return (
    <Box
      component="input"
      type="number"
      min={0}
      step={1}
      title={hasError ? 'Min cannot exceed Max' : title}
      value={value ?? ''}
      onChange={(e) => {
        const v = e.target.value === '' ? null : Number(e.target.value);
        onChange(v);
      }}
      sx={{
        width: '100%',
        minWidth: 56,
        height: 32,
        px: 1,
        bgcolor: bg,
        color: fg,
        fontWeight: dev || hasError ? 700 : 500,
        fontSize: 13,
        borderRadius: 1,
        border: 1,
        borderColor: hasError ? '#ef4444' : 'divider',
        borderLeftWidth: 3,
        borderLeftStyle: 'solid',
        borderLeftColor: hasError ? '#ef4444' : (SOURCE_COLORS[source] || SOURCE_COLORS.manual),
        outline: 'none',
        textAlign: 'center',
        '&:focus': {
          borderColor: hasError ? '#ef4444' : 'primary.main',
          boxShadow: hasError ? '0 0 0 2px rgba(239,68,68,0.2)' : '0 0 0 2px rgba(79,70,229,0.2)',
        },
      }}
    />
  );
}
